import React from 'react';
import { Input, InputGroup, InputLeftElement, Select } from '@chakra-ui/react';
import { FaSearch } from 'react-icons/fa';
import PropTypes from 'prop-types';

const SearchBar = ({ data, handleSearch, sortBySearch, sortBy }) => {
  return (
    <InputGroup maxW='lg'>
      <InputLeftElement pointerEvents='none'>
        <FaSearch />
      </InputLeftElement>
      <Input
        type='text'
        placeholder='Search Here...'
        onChange={(q) => handleSearch(q.target.value)}
      />
      <Select
        onChange={(e) => sortBySearch(e)}
        value={sortBy}
        placeholder='Sort By'
        ml={2}
        borderRadius='none'>
        <option value='create_time'>Sort By</option>
        <option value='digg_count'>Likes</option>
        <option value='play_count'>Views</option>
        <option value='create_time'>Creation Time</option>
      </Select>
    </InputGroup>
  );
};

export default SearchBar;

SearchBar.propTypes = {
  data: PropTypes.any.isRequired,
  sortBy: PropTypes.any.isRequired,
  handleSearch: PropTypes.func.isRequired,
  sortBySearch: PropTypes.func.isRequired,
};
